import { Injectable } from "@angular/core";

import { ValApiResultat, ValBaseService } from "../../../../val-ammon-services/val-services-communs-lib/src/public-api";
import { ValAppSettingsService } from "../../../../val-ammon-services/val-app-settings-lib/src/public-api";
import { RetournerParametrageClientResultat } from "./RetournerParametrageClientResultat";
import { CorbeilleGedEFact } from "./RetournerCorbeillesGedResultat";

//eFact paramétrages service
//  Lit le paramétrage client directement sur l’API eFact. La route homonyme d’Ammon
//  Services n’est pas utilisable ici : EFactParametrageController est marqué
//  [ApplicationRequise(ApplicationsPlateforme.Services)], donc fermé au front eFacture.
@Injectable (
{
  providedIn: 'root'
})
export class EFactParametragesService extends ValBaseService
{
  //Création
  //  Paramètres
  //    appSettingsService : Service d’accès à la configuration de l’application
  constructor (private appSettingsService: ValAppSettingsService)
  {
    super ();
  }

  //Url de base
  protected override get BaseUrl () : string
  {
    return `${this.appSettingsService.Configuration.UrlApi.EFact}/v1.0/parametrages/`;
  }

  //Retourne le paramétrage e-Facture du client
  //  Un client jamais paramétré est rendu avec des champs vides, pas en erreur.
  //  Retourne
  //    Résultat de la récupération du paramétrage e-Facture du client
  public async RetournerParametrageClient () : Promise<ValApiResultat<RetournerParametrageClientResultat>>
  {
    let operation: Promise<ValApiResultat<RetournerParametrageClientResultat>>;

    operation = this.ExecuterRequeteGet<RetournerParametrageClientResultat> ("client");

    return operation;
  }

  //Retourne les corbeilles GED des factures d’achat du client (SU #120249)
  //  Toutes les corbeilles sont rendues, actives ou non : le filtrage des corbeilles affectables
  //  revient à l’appelant.
  //  Retourne
  //    Résultat de la récupération des corbeilles GED du client
  public async RetournerCorbeillesGed () : Promise<ValApiResultat<CorbeilleGedEFact[]>>
  {
    let operation: Promise<ValApiResultat<CorbeilleGedEFact[]>>;

    operation = this.ExecuterRequeteGet<CorbeilleGedEFact[]> ("corbeilles-ged");

    return operation;
  }
}
